import React from 'react'
import { CGE } from '../../../../common/components/CGE'

import ChangePasswordContextProvider, {ACTIONS, ChangePasswordContext} from '../../context/ChangePasswordContextProvider';

function ChangePasswordController({props}) {
    const [state, dispatch] = React.useContext(ChangePasswordContext);
    const [values, setValues] = React.useState({})
    const [inputValidate, setInputValidate] = React.useState({
        empty: {},
        validated: {},
        msg: {}
    });
    const [checkPassword, setCheckPassword] = React.useState({})


    function funcValidate() {
        let errors = {
            empty: {},
            validated: {},
            msg: {}
        };

        if (values.oldPassword) {
            errors.empty.oldPassword = false;
        } else {
            errors.empty.oldPassword = true;
            errors.msg.oldPassword = "Debe ingresar el contraseña actual"
        }

        if (values.newPassword) {
            errors.empty.newPassword = false;
        } else {
            errors.empty.newPassword = true;
            errors.msg.newPassword = "Debe ingresar el contraseña nueva"
        }

        if (values.confirmNewPassowrd) {
            errors.empty.confirmNewPassowrd = false;
        } else {
            errors.empty.confirmNewPassowrd = true;
            errors.msg.confirmNewPassowrd = "Debe ingresar el confirmacion del contraseña nueva"
        }

        setInputValidate(errors)
        return errors
    }

    function handleSubmit(){
        const objErros = funcValidate();
        if (Object.values(objErros?.msg).length > 0) {
            props.setGlobalAlert("Complete todos los campos obligatorios.","warning");
        } else if((Object.entries(checkPassword).filter(([key, value]) =>  value === false).length > 0)){
            props.setGlobalAlert("Complete todos los campos obligatorios correctamente.","warning");
            setInputValidate({...inputValidate, ...inputValidate.empty.newPassword = true, ...inputValidate.msg.newPassword = "La contraseña debe respetar las reglas a continuación.", ...inputValidate.empty.confirmNewPassowrd = false, ...inputValidate.msg.confirmNewPassowrd = ""})
        } else if(values.newPassword !== values.confirmNewPassowrd) {
            props.setGlobalAlert("Las contraseñas deben ser las mismas.","warning");
            setInputValidate({...inputValidate, ...inputValidate.empty.confirmNewPassowrd = true, ...inputValidate.msg.confirmNewPassowrd = "Las contraseñas deben ser las mismas.", ...inputValidate.empty.newPassword = false, ...inputValidate.msg.newPassword = "",})
        } else {
            dispatch({
                payload: {old:values.oldPassword, new:values.newPassword},
                type: ACTIONS.SET_FORM_DATA,
            });
        }
    }

    function initialState() {
        setValues({});
        setInputValidate({
            empty: {},
            validated: {},
            msg: {}
        });
    }

    React.useEffect(() => {
        if(state.responseData) {
            const objResponse = state.responseData;
            
            switch(objResponse?.response?.status) {
                case 200:
                    props.setGlobalAlert("Contraseña alterada con éxito", "success",true,"Confirmación");
                break;
                case 500:
                    props.setGlobalAlert("El servicio no está disponible actualmente, intente más tarde.", "warning",true,"Atención");
                break;
                case 400:
                    props.setGlobalAlert("Por favor, compruebe sus datos y vuelva a intentarlo.", "warning",true,"Atención");
                break;
                default:
                    props.setGlobalAlert("El servicio no está disponible actualmente, intente más tarde.", "warning",true,"Atención");
                break;
            }         
        }
    },[state.responseData]);

    function checkPasswordFunc(password){
        let checkPass = {}
        let m;
        if( !(m = password.match(/[a-z]/g))){
             checkPass.lowerCase = false
        } else {
            checkPass.lowerCase = true
        }

        if( !(m = password.match(/[A-Z]/g))){
            checkPass.upperCase = false
        } else {
            checkPass.upperCase = true
        }

        if( !(m = password.match(/[0-9]/g))){
            checkPass.containsNumber = false
        } else {
            checkPass.containsNumber = true
        }

        if(password.length < 8){
            checkPass.minLength = false
        } else {
            checkPass.minLength = true
        }

        setCheckPassword(checkPass)
        return checkPass
    }

  return (
    <div>
        <CGE.Panel title={props.title_cambio_contrasena}>
            <CGE.PanelSectionTicket title={props.title_section_cambio_contrasena_1}>
                <CGE.PanelContainer
                    alingItensCenter={true}
                    size="md">
                    <CGE.FormsField
                        handleChange={(e) => setValues({ ...values, oldPassword: e.target.value })}
                        idFormElement="oldPassword"
                        mandatoryElement={true}
                        horizontal={true}
                        labelName="Contraseña Actual:"
                        labelStyle={{ fontSize: "14px"  }}
                        typeElement="input"
                        hasError={inputValidate?.empty?.oldPassword}
                        msgError={inputValidate?.msg?.oldPassword}
                        value={values.oldPassword}
                        style={{ "-webkit-text-security" : "disc" }}
                        typeFormElement="text"
                        
                    />
                </CGE.PanelContainer>
            </CGE.PanelSectionTicket>
            <CGE.PanelSectionTicket title={props.title_section_cambio_contrasena_2}>
                <CGE.PanelContainer
                    alingItensCenter={true}
                    size="md">
                    <CGE.FormsField
                        handleChange={(e) => 
                            {
                                setValues({ ...values, newPassword: e.target.value });
                                checkPasswordFunc(e.target.value);
                            }

                        }
                        idFormElement="oldPassword"
                        mandatoryElement={true}
                        horizontal={true}
                        labelName="Contraseña Nueva:"
                        labelStyle={{ fontSize: "14px"  }}
                        typeElement="input"
                        hasError={inputValidate?.empty?.newPassword}
                        msgError={inputValidate?.msg?.newPassword}
                        value={values.newPassword}
                        style={{ "-webkit-text-security" : "disc" }}
                        typeFormElement="text"
                        
                    />
                </CGE.PanelContainer>
                <CGE.PanelContainer
                    alingItensCenter={true}
                    size="md">
                    <CGE.FormsField
                        handleChange={(e) => setValues({ ...values, confirmNewPassowrd: e.target.value })}
                        idFormElement="confirmNewPassowrd"
                        mandatoryElement={true}
                        horizontal={true}
                        labelName="Confirmar Contraseña Nueva:"
                        labelStyle={{ fontSize: "14px"  }}
                        typeElement="input"
                        hasError={inputValidate?.empty?.confirmNewPassowrd}
                        msgError={inputValidate?.msg?.confirmNewPassowrd}
                        value={values.confirmNewPassowrd}
                        style={{ "-webkit-text-security" : "disc" }}
                        typeFormElement="text"
                        
                    />
                </CGE.PanelContainer>
                <CGE.PanelContainer
                    alingItensCenter={true}
                    size="sm"
                >
                    <div className="d-flex flex-column">
                        <CGE.FieldCheckPassowd
                            checked={checkPassword?.lowerCase}
                            labelName={props.condition_cambio_contrasena_1}
                        />
                        <CGE.FieldCheckPassowd
                            checked={checkPassword?.upperCase}
                            labelName={props.condition_cambio_contrasena_2}
                        />
                        <CGE.FieldCheckPassowd
                            checked={checkPassword?.containsNumber}
                            labelName={props.condition_cambio_contrasena_3}
                        />
                        <CGE.FieldCheckPassowd
                            checked={checkPassword?.minLength}
                            labelName={props.condition_cambio_contrasena_4}
                        />
                    </div>
          
                </CGE.PanelContainer>

            </CGE.PanelSectionTicket>
            <div className="d-flex justify-content-end">
                <CGE.Button
                    label="Aceptar"
                    onClick={() => handleSubmit()}
                />
            </div>
        </CGE.Panel>
    </div>
  )
}

const ChangePasswordControllerWithProvider = ({ props }) => (
    <ChangePasswordContextProvider>
        <ChangePasswordController props={props} />
    </ChangePasswordContextProvider>
);
export default ChangePasswordControllerWithProvider;